import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static get values() {
    return { enabled: { type: Boolean, default: true } }
  }

  connect() {
    this.tooltip = new bootstrap.Tooltip(this.element)

    if (!this.enabledValue) {
      this.disable()
    }
  }

  disconnect() {
    // Hide the tooltip on disconnect to prevent lingering tooltips
    this.tooltip?.hide()
  }

  enable() {
    this.enabledValue = true
    this.tooltip?.enable()
  }

  disable() {
    this.enabledValue = false
    this.tooltip?.disable()
  }
}
